/**
 * Terms service
 */

import Resource from './resource'

export default new Resource('terms')



// WEBPACK FOOTER //
// ./src/libraries/services/terms.js